export const VERSION_CACHE_BUSTER_PARAM = "brickantaReload";
export const DISMISSED_VERSION_KEY = "byggve_dismissed_version";

export const reloadAppWithoutCache = () => {
  if (typeof window === "undefined") {
    return;
  }

  // Add cache buster to URL before reload
  const url = new URL(window.location.href);
  url.searchParams.set(VERSION_CACHE_BUSTER_PARAM, Date.now().toString());

  // Use history.replaceState to update URL without triggering navigation
  window.history.replaceState({}, document.title, url.toString());

  // Force a hard reload that bypasses cache
  window.location.reload();
};

export const clearCacheBusterParam = () => {
  if (typeof window === "undefined") {
    return;
  }

  const url = new URL(window.location.href);
  if (!url.searchParams.has(VERSION_CACHE_BUSTER_PARAM)) {
    return;
  }

  url.searchParams.delete(VERSION_CACHE_BUSTER_PARAM);
  window.history.replaceState({}, document.title, url.toString());
};

export const clearDismissedVersion = () => {
  if (typeof window === "undefined") {
    return;
  }

  localStorage.removeItem(DISMISSED_VERSION_KEY);
};
